module.exports = __webpack_public_path__ + "img/equtcloud-150.97573fe7.svg";